import { findDOMNode } from 'react-dom';
import { TimelineLite, RoughEase, Linear } from 'gsap';
import ScrollMagic from '../../plugins/ScrollMagic';
import '../../plugins/debug.addIndicators';

export default {

    initialiseShake(container, level = 0) {
        this.node = findDOMNode(container);
        this.tags = this.node.querySelectorAll('h1, .move-me');
        this.levels = {
            0: {strength: 8, min: -1, max: 1},
            0.5: {strength: 8, min: -1, max: 1},
            1: {strength: 8, min: -2, max: 2},
            2: {strength: 8, min: -2, max: 2},
            3: {strength: 8, min: -3, max: 3}
        };

        this.setTimeline();
        this.shake(level);

        return this.tl;
    },

    mergeHeadings(container, shakeTl) {
        this.node = findDOMNode(container);
        this.heading = this.node.querySelector('h1');

        shakeTl.clear();
        this.heading.style.transform = 'none';
    },

    unMergeHeadings(container, shakeTl, positions) {
        let tl = new TimelineLite();

        return tl.add(() => {
            return this.initialiseShake(container);
        });
    },

    getSpanPositions(container) {
        this.node = findDOMNode(container);
        this.tags = this.node.querySelectorAll('.move-me');

        let positions = {};

        this.tags.forEach((item, key) => {
            let style = getComputedStyle(item);
            positions[key] = {left: style.left, top: style.top};
        });

        return positions;
    },

    shake(level) {
    	if (level >= 0) {
			this.tags.forEach((item) => {
				let settings = this.levels[level],
					//max = this.random(1, settings.max),
					//min = this.random(settings.min, -1),
					duration = (level > 1 ? 0.3 : 0.2);

				this.tl.fromTo(item, duration, {
					x: settings.min,
					y: 0,
				}, {
					x: settings.max,
					y: 0,
					ease: RoughEase.ease.config({
						strength: settings.strength,
						points: 20,
						template: Linear.easeNone,
						randomize: true
					}),
					clearProps: "x, y"
				}, 0);
			});
		}
    },

    setTimeline() {
        this.tl = new TimelineLite({
            onComplete: function() {
                this.restart();
            }
        });
    },

    random(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    },

	animateOnScroll(mergeFunc, unMergeFunc) {
    	let controller = new ScrollMagic.Controller();

    	new ScrollMagic.Scene({
			triggerElement: '#intro1',
			offset: -150
		})
			//.addIndicators({name: 'animate-on-scroll'})
			.addTo(controller)
			.on('enter', event => {
				mergeFunc();
			})
			.on('leave', event => {
				unMergeFunc();
			});
	}

};


// WEBPACK FOOTER //
// ./src/js/views/Home/animations.js